import AddIcon from '@/assets/AddIcon';
import SubtractIcon from '@/assets/SubtractIcon';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, CircularProgress, IconButton } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { MouseEventHandler } from 'react';

type UpdateQuantityButton = {
	amount: number;
	onAdd: () => void;
	onReduce: () => void;
	isLoading: boolean;
	availableQuantity: number;
};

const UpdateQuantityButton = (props: UpdateQuantityButton) => {
	function onAddClicked(e: any) {
		e.stopPropagation();
		props.onAdd();
	}

	function onReduceClicked(e: any) {
		e.stopPropagation();
		props.onReduce();
	}
	return (
		<FlexBox
			sx={{
				padding: '0px 14px',
				height: '30px',
				justifyContent: 'space-evenly',
				border: `1px solid ${getColor('Minty 0')}`,
				alignItems: 'center',
				borderRadius: '20px',
				// boxShadow: '-1px 11px 11px -8px rgb(6 155 170 / 66%)',
			}}
		>
			<Box sx={{ padding: '4px' }}>
				<IconButton
					disabled={props.isLoading}
					onClick={onReduceClicked}
					sx={{ p: '0px' }}
				>
					<SubtractIcon />
				</IconButton>
			</Box>
			<FlexBox
				width='30px'
				height='35px'
				alignItems={'center'}
				justifyContent='center'
			>
				{props.isLoading ? (
					<CircularProgress />
				) : (
					<LencoTypography
						sx={{
							...getStyle('Small_SemiBold'),
							color: getColor('Gray 0'),
							margin: '8px 16px',
						}}
					>
						{props.amount}
					</LencoTypography>
				)}
			</FlexBox>
			<Box sx={{ padding: '4px' }}>
				<IconButton
					disabled={props.isLoading}
					onClick={onAddClicked}
					sx={{ p: '0px' }}
				>
					<AddIcon />
				</IconButton>
			</Box>
		</FlexBox>
	);
};

export default UpdateQuantityButton;
